import { render, staticRenderFns } from "./FormsList.vue?vue&type=template&id=4745b7c0&"
import script from "./FormsList.vue?vue&type=script&lang=js&"
export * from "./FormsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports